// Login.js
import { useState, useRef, useEffect } from "react";
import { Box, Button, Image, Text, TextInput, Grommet, Spinner } from "grommet";
import { useNavigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth,  } from "./firebase";
// import ResetPassword from "./ResetPassword";

const theme = {
    global: {
        font: {
            family: "Arial",
        },
        colors: {
            primary: "#447338",
            accent: "#c1de36",
            border: "#c1de36",
        },
    },
};

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const isMounted = useRef(true);
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleLogin = async () => {
        if (!email || !password) {
            setError("Please enter both email and password.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            // console.log("Logged in user:", user);
            // console.log("Logged in:", user.email);
            // console.log("My UID is:", auth.currentUser?.uid);

            navigate("/");
        } catch (err) {
            console.error("Login error:", err.message);
            if (isMounted.current) setError("Login failed: " + err.message);
        } finally {
            if (isMounted.current) setLoading(false);
        }
    };


    return (
        <Grommet theme={theme} full>
            <Box
                fill 
                align="center"
                justify="center"
                background="white"
                pad="medium"
                overflow="hidden"
            >
                <Box
                    width="medium"
                    pad="medium"
                    gap="medium"
                    round="small"
                    border={{ color: "border", size: "xsmall" }}
                    background="light-1"
                    elevation="small"
                >
                    <Box height="small" width="small" alignSelf="center">
                        <Image src="BgPic.png" fit="contain" />
                    </Box>

                    <Text size="large" weight="bold" alignSelf="center" color="primary">
                        Login
                    </Text>

                    <Box gap="small">
                        <TextInput
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{
                                border: `1px solid #c1de36`,
                                borderRadius: "5px",
                                padding: "8px",
                            }}
                        />
                        <TextInput
                            placeholder="Password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{
                                border: `1px solid #c1de36`,
                                borderRadius: "5px",
                                padding: "8px",
                            }}
                        />
                    </Box>

                    {error && (
                        <Text color="status-critical" size="small">
                        {error}
                        </Text>
                    )}

                    <Button
                        onClick={handleLogin}
                        disabled={loading}
                        label={
                            loading ? (
                            <Box direction="row" gap="small" align="center">
                                <Spinner size="xsmall" color="white" />
                                <Text color="white">Logging in...</Text>
                            </Box>
                            ) : (
                            <Text color="white">Login</Text>
                            )
                        }
                        style={{
                            backgroundColor: '#447338',
                            borderRadius: '4px',
                            padding: '8px 16px',
                            border: '1px solid #c1de36',
                        }}
                    />

                    <p>
                        <Link to="/reset-password" state={{ email }}>
                            Forgot Password?
                        </Link>
                    </p>

                </Box>
            </Box>
        </Grommet>
    );
}

export default Login;
